enum DeviceType {
  mobile = 1,
  borne,
  landscape,
  widget,
}

export { DeviceType }
